import dynamic from 'next/dynamic';

import { Accordion } from '@natu/ui/Accordion';

import {
  type BlokItem,
  DynamicRender,
  type SBProps,
  type Spacing,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';
import type { SBAccordionItemProps } from './SBAccordionItem';

const FaqSchemaFromAccordion = dynamic(() =>
  import('./FaqSchemaFromAccordion').then(mod => mod.FaqSchemaFromAccordion),
);

interface SBAccordionProps {
  autogenerateFaqSchema?: boolean;
  sendEvent?: boolean;
  items?: BlokItem[];
  type?: 'multiple' | 'single';
  disabled?: boolean;
  collapsible?: boolean;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBAccordion = ({ blok }: SBProps<SBAccordionProps>) => {
  const {
    autogenerateFaqSchema,
    sendEvent,
    items,
    type,
    disabled,
    collapsible,
    mbMobile,
    mbTablet,
    mbDesktop,
    mtMobile,
    mtTablet,
    mtDesktop,
  } = blok;

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  return (
    <div className={className} {...sbEditable(blok)}>
      <Accordion
        disabled={disabled}
        type={type || 'multiple'}
        collapsible={type === 'single' ? collapsible : undefined}
      >
        <DynamicRender
          data={items}
          parentProps={{ event: sendEvent ? 'E_FAQ_expand' : undefined }}
        />
      </Accordion>
      {autogenerateFaqSchema && <FaqSchemaFromAccordion items={items as SBAccordionItemProps[]} />}
    </div>
  );
};
